import React, { useEffect, useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import AdminTopbar from './AdminTopbar';
import { AdminPeriodProvider } from '../../contexts/AdminPeriodContext';
import { content as contentApi } from '../../services/apiClient';
import '../admin.css';

const DEFAULT_ADMIN_THEME = {
  palette: {
    background: '#0B0B0F',
    surface: '#12121A',
    border: '#1F1F2A',
    text: '#FFFFFF',
    muted: '#B8B8C5',
    accent: '#FF6A00'
  }
};

export default function AdminLayout() {
  const [adminTheme, setAdminTheme] = useState(DEFAULT_ADMIN_THEME);

  useEffect(() => {
    document.body.classList.add('admin-body');
    document.documentElement.classList.add('admin-html');
    return () => {
      document.body.classList.remove('admin-body');
      document.documentElement.classList.remove('admin-html');
    };
  }, []);

  useEffect(() => {
    const handler = (event) => {
      if (!event?.detail) return;
      const data = event.detail;
      setAdminTheme({
        ...DEFAULT_ADMIN_THEME,
        ...data,
        palette: { ...DEFAULT_ADMIN_THEME.palette, ...(data?.palette || {}) }
      });
    };
    window.addEventListener('admin-theme-updated', handler);
    return () => window.removeEventListener('admin-theme-updated', handler);
  }, []);

  useEffect(() => {
    let mounted = true;
    const loadTheme = async () => {
      try {
        const data = await contentApi.getAdminTheme();
        if (mounted && data) {
          setAdminTheme({
            ...DEFAULT_ADMIN_THEME,
            ...data,
            palette: { ...DEFAULT_ADMIN_THEME.palette, ...(data?.palette || {}) }
          });
        }
      } catch {
        if (mounted) setAdminTheme(DEFAULT_ADMIN_THEME);
      }
    };
    loadTheme();
    return () => { mounted = false; };
  }, []);

  const themeStyle = useMemo(() => ({
    '--admin-bg': adminTheme.palette.background,
    '--admin-surface': adminTheme.palette.surface,
    '--admin-border': adminTheme.palette.border,
    '--admin-text': adminTheme.palette.text,
    '--admin-muted': adminTheme.palette.muted,
    '--admin-accent': adminTheme.palette.accent,
  }), [adminTheme]);

  return (
    <AdminPeriodProvider>
      <div className="admin-app" style={themeStyle}>
        <AdminSidebar />
        <div className="admin-main">
          <AdminTopbar />
          <div className="admin-content">
            <Outlet />
          </div>
        </div>
      </div>
    </AdminPeriodProvider>
  );
}
